import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ErrorService } from 'src/app/core/errors/error.service';
import { catchError, EMPTY } from 'rxjs';
import { AppContextService } from 'src/app/data/services/app-context.service';

@Component({
  selector: 'app-bug-report-dialog',
  templateUrl: './bug-report-dialog.component.html',
  styleUrls: ['./bug-report-dialog.component.css'],
  standalone: true,
  imports: [FormsModule],
})
export class BugReportDialogComponent {

  userFeedback: string = "";
  sending: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<BugReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private errorService: ErrorService,
    private appContext: AppContextService
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  sendFeedback(): void {
    if (!this.userFeedback.trim()) {
      return;
    }

    this.sending = true;

    this.errorService.sendErrorNotification(this.userFeedback, this.data.request, this.appContext.isMoodle ? 'Moodle' : 'Levelab')
    .pipe(
      catchError((notificationError) => {
        console.warn('Failed to send error notification:', notificationError);
        return EMPTY;
      })
    ).subscribe();
        
    this.sending = false;
    this.close();
  }
}

